// extracted by mini-css-extract-plugin
export default {"box":"Values_box__3xpsf","boxIcon":"Values_boxIcon__wWIkf"};